import React from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import config from 'sharedConfig';
import { breadcrumbsFor } from './breadcrumbs';

export default function ProductHeadTags(props) {
  const product = props.product;
  const parentCategories = props.parentCategories;
  const fullProductName =
    product.title + (product.subtitle ? ` – ${product.subtitle}` : '');
  const pageTitle = `${fullProductName} | Saucey`;
  const description = product.description || product.subtitle;
  const keywords = [product.title, product.subtitle, product.description].join(
    ' '
  );
  const productPath = product.url || '';
  const url =
    config.site.url +
    (productPath.indexOf('/') === 0 ? productPath : '/' + productPath);

  const productData = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: fullProductName,
    image: product.image,
    description,
    brand: {
      '@type': 'Brand',
      name: _.startCase(product.company || product.brand || product.title)
    },
    sku: product.sku_id,
    offers: [
      {
        '@type': 'AggregateOffer',
        lowPrice: product.minPrice,
        highPrice: product.maxPrice,
        priceCurrency: 'USD'
      }
    ]
  };

  const ratings = props.ratings || {};
  const ratingValue = ratings.ratingValue;
  const reviewCount = ratings.ratingCount;

  if (parseInt(ratingValue) > 0) {
    productData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue,
      reviewCount
    };
  }

  const breadcrumbs = breadcrumbsFor(parentCategories);
  const listItems = breadcrumbs.map(({ name, url }, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    item: {
      '@id': config.site.url + url,
      name: name
    }
  }));
  const breadcrumbsData = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: listItems.concat({
      '@type': 'ListItem',
      position: listItems.length + 1,
      item: {
        '@id': url,
        name: fullProductName,
        image: product.image
      }
    })
  };

  const structuredData = [productData, breadcrumbsData].map(data => {
    return { key: data['@type'], json: JSON.stringify(data) };
  });

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="product" />
      <meta property="og:title" content={fullProductName} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={product.image} />
      <meta property="og:image:width" content="600" />
      <meta property="og:image:height" content="550" />
      <meta property="twitter:title" content={fullProductName} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={product.image} />
      <meta
        name="twitter:app:url:iphone"
        content={`saucey://product/${product.sku_id}`}
      />
      <meta
        name="apple-itunes-app"
        content={`app-id=869556845, app-argument=saucey://product/${product.sku_id}`}
      />
      {structuredData.map(sd => (
        <script type="application/ld+json" key={sd.key}>
          {sd.json}
        </script>
      ))}
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./shared/components/product/head.js